import _styled from "../../../../../_snowpack/pkg/styled-components.js";
import React, { useRef, useState } from '../../../../../_snowpack/pkg/react.js';
import { useLocation, useHistory } from '../../../../../_snowpack/pkg/react-router-dom.js';
import { useLanguage, useTenantLanguages, useOnClickOutside } from '../../../../hooks/index.js';
import { Filter, Heading, List, ListItem } from './styles.js';

var _StyledDiv = _styled("div").withConfig({
  displayName: "language-menu___StyledDiv",
  componentId: "bti1xa-0"
})(["padding:0.5rem;"]);

function Multilingual({
  handleClose
}) {
  const {
    language,
    setLanguage
  } = useLanguage();
  const availableLanguages = useTenantLanguages();
  const location = useLocation();
  const history = useHistory();
  const [filterString, setFilterString] = useState('');
  const wrapperRef = useRef(null);
  useOnClickOutside(wrapperRef, handleClose);
  const selectedLang = availableLanguages.find(lang => {
    return lang.code === language;
  });

  if (!availableLanguages.length) {
    return null;
  }

  const handleFilter = event => {
    setFilterString(event.target.value);
  };

  const handleLanguageSelection = code => event => {
    event.stopPropagation();
    setLanguage(code);
    handleClose();
    const firstPath = location.pathname.match(/^(\/[^/]+)/);
    history.replace(firstPath ? firstPath[0] : '/');
  };

  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(Heading, null, "Language"), /*#__PURE__*/React.createElement(List, null, availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages.filter(({
    code,
    name
  }) => {
    return code.toLowerCase().includes(filterString.toLowerCase()) || name.toLowerCase().includes(filterString.toLowerCase());
  }).map(({
    code,
    name
  }) => {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: code,
      selected: code === language,
      onClick: handleLanguageSelection(code),
      "data-cypress": `${name}-language`
    }, /*#__PURE__*/React.createElement("span", {
      className: "code"
    }, code), /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, name));
  })), /*#__PURE__*/React.createElement(Filter, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "language"
  }, selectedLang === null || selectedLang === void 0 ? void 0 : selectedLang.code), /*#__PURE__*/React.createElement("input", {
    name: "language",
    onChange: handleFilter,
    placeholder: selectedLang === null || selectedLang === void 0 ? void 0 : selectedLang.name,
    type: "text",
    value: filterString
  })));
}

export default Multilingual;